/* @flow */
import React from 'react';
import linksMessages from '../../common/app/linksMessages';
import messages from '../../common/notfound/messages';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const NotFoundPage = ({ intl }) => (
  <div>
      {intl.formatMessage(messages.p)}
      {intl.formatMessage(messages.h1)}
      <FormattedMessage {...messages.continue} />
  </div>
);

NotFoundPage.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(NotFoundPage);



// WEBPACK FOOTER //
// ./src/browser/notfound/NotFoundPage.js